import UserLayout from "../components/UserLayout";
import Members from "../components/Members";

const MembersPage = () => {
    return (
        <UserLayout>
            <Members />
        </UserLayout>
    );
}

export default MembersPage;